import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { xIcon } from '@progress/kendo-svg-icons';
import { ProgressBar } from '@progress/kendo-react-progressbars';
import {
  NotificationCenterItem,
  useGlobalizationContext,
  useTranslation,
  useCurrentUserContext
} from '@cs-cms/state-management';
import { getRelativeTime } from '@cs-cms/utils';

interface NotificationItemProps {
  notification: NotificationCenterItem;
  onRetry?: () => void;
  onRemove?: () => void;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onRetry, onRemove }) => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { selectedIndex } = useCurrentUserContext();
  const hasProgress = notification.type === 'progress' && notification.progress;
  const buttonTitle =
    notification.formRetryData?.retryIndex.id === selectedIndex?.id
      ? translate('custom.notifications.notificationCenter.restoreAndRetry')
      : translate('custom.notifications.notificationCenter.navigateAndRetry');

  return (
    <div>
      <div className="notificationTitleWrapper">
        <p className="notificationTitle">{notification.title}</p>
        {onRemove && <Button className="removeNotificationButton" svgIcon={xIcon} onClick={onRemove} />}
      </div>
      <p className="notificationMessage">{notification.message}</p>

      {hasProgress && (
        <div>
          <span>{notification.progress?.percent}%</span>
          <ProgressBar
            value={notification.progress?.percent ?? 0}
            max={100}
            animation={notification.type === 'progress'}
            labelVisible={false}
          />
        </div>
      )}

      <p className="notificationTime">{getRelativeTime(notification.timestamp)}</p>

      {notification.formRetryData && onRetry && <Button onClick={onRetry}>{buttonTitle}</Button>}
    </div>
  );
};
